import { classnames } from '@aibees/shared/utils';
import { Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { WorkHistoryDurationProps as Props } from './types';
import { currentCompanyDuration } from './utils';

export const WorkHistoryDuration = memo(({ className, item }: Props) => {
  const duration = currentCompanyDuration(item);
  return (
    <Styled.Wrapper
      className={classnames('WorkHistoryDuration', className)}
      sx={SX.root}
    >
      <Typography color="grey.500" variant="body4" fontWeight={400}>
        {duration}
      </Typography>
    </Styled.Wrapper>
  );
});

WorkHistoryDuration.displayName = 'WorkHistoryDuration';
